import { getCustomerProfile } from '../../../../utils/data/get-customer-profile';
import { getProfilePicture } from '../../../../utils/data/get-profile-picture';
import { getProfileDisplayName } from '../../../../utils/helpers/get-profile-display-name';
import { type ProfileSummary } from '../../../../utils/types/profile-summary';

export const getProfileSummary = async (personId: number): Promise<ProfileSummary> => {
  const customerProfile = await getCustomerProfile({ personId });
  const profilePicture = customerProfile?.hasProfilePicture
    ? await getProfilePicture({ personId, size: 112 })
    : null;
  const profileDisplayName = getProfileDisplayName(customerProfile);

  return {
    displayName: profileDisplayName,
    mdrtId: customerProfile?.mdrtId || null,
    photoUrl: profilePicture,
  };
};
